<template>
  <div>
    <NuxtLoadingIndicator color="#ffd55b" :height="3" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
